<template>
  <div>
    <navigation-main bg="true" />

    <div class="main-content">
      <div class="" data-spy="scroll" data-target="#mainNav" data-offset="75">
        <main role="main" class="flex-grow-1 overflow-auto">
          <div id="content">
            <!-- ECCV Acceptance -->
            <section class="page-section" id="eccv-acceptance">
              <div class="container">
                <div class="row mt-3">
                  <div class="col-lg-12 mt-2">
                    <div>
                      <h2
                        class="text-black mt-0"
                        style="color:black !important;"
                      >
                        ECCV Acceptance - July 17, 2024
                      </h2>
                      <hr class="divider dark" style="max-width: 100%" />
                    </div>
                    <p class="mb-4">
                      We are happy to announce that MUSES was accepted at ECCV 2024.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            <!-- Dataset released -->
            <section class="page-section" id="release">
              <div class="container">
                <div class="row mt-3">
                  <div class="col-lg-12 mt-2">
                    <div>
                      <h2
                        class="text-black mt-0"
                        style="color:black !important;"
                      >
                        Dataset released - May 29, 2024
                      </h2>
                      <hr class="divider dark" style="max-width: 100%" />
                    </div>
                    <p class="mb-4">
                      MUSES, the MUlti-SEnsor Semantic perception dataset, is released.
                    </p>
                    <a
                      class="btn btn-secondary btn-xl js-scroll-trigger"
                      href="../download"
                      >Get Started!</a
                    >
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "../style/_variables.scss";
@import "../style/mixins.scss";

.carousel-item img {
  height: calc(100vh - 60px) !important;
  object-fit: cover !important;
  filter: blur(2px);
}

.textbox-main {
  background-color: #02000000;
}

.carousel-caption {
  bottom: 50% !important;
}
</style>
<script>
import { mapState } from "vuex";
import NavigationMain from "@/views/navigation/navigation-main";

export default {
  components: { NavigationMain },
  computed: {
    ...mapState({
      account: state => state.account
    })
  }
};
</script>
